import { useDispatch, useSelector } from "react-redux"
import {
  useFetchWithBody,
  usePost,
} from "../../api/reactQueryCustomHooks"
import { apiRoute, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, GetLoginCredentialDb, getModValue, linksUrl } from "../../constants/enum"
import {
  ErrorCard,
  LoadingCard,
  MainContainer,
  NextUITable,
} from "../../components"
import {
  Button,
} from "@nextui-org/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faEdit,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons"

import {
  COLUMN_ALIGN_TYPE,
  COLUMN_TYPE,
  FOOTER_TYPE,
  ROW_ACTION_BTN_TYPE,
} from "../../components/NextUITable"
import { useNavigate } from "react-router-dom"
import { useEffect, useMemo, useState } from "react"
import { calculateTotal } from "../../Utility/utility"
import { toast } from "react-toastify"
import ConfirmBox from "../../components/ConfirmBox"
import { resetDetailParams, setDetailParam, setDetailParams, setNewEntryMode } from "../../state/beamCardSlice"

const BeamCardMaster = () => {
  let disapatch = useDispatch()
  let navigate = useNavigate()
  const { token, user } = useSelector((state) => state.auth)
  const { compCode, isMultipleCompany } = useSelector((state) => state.company)
  let [itemToDelete, setItemToDelete] = useState("")

  useEffect(() => {
    if (isMultipleCompany)
      navigate("/dashboard")
    disapatch(resetDetailParams())
  }, [])


  const {
    isError,
    isPending,
    data = [],
    mutate: filterData
  } = usePost({
    url: apiRoute.beamTransaction.beamCardEntry.fetch,
    queryKey: "Beam Card Data List",

  })
  const funFilterData = () => {
    filterData({
      data: {
        compcode: compCode.join(","),
      }
    })

  }
console.log(data)
  useEffect(() => {
    funFilterData();
  }, [])

console.log(data)

  const onSuccessDelete = (data) => {
    setItemToDelete("")
    toast.success("deleted successfully", {
      position: "top-center"
    })
    funFilterData();
  }

  const { mutate: FndeleteNote } = usePost(
    {
      url: apiRoute.beamTransaction.beamCardEntry.deleteEntry,
      query: "delete-beam-card",
      onSuccessTasks: onSuccessDelete
    }
  )

  let totalTAKA = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "taka",
      }),
    [data]
  )

  const INITIAL_VISIBLE_COLUMNS = [
    "actions",
    "unit_name",
    "item_name",
    "beam_no",
    "taka",
    "meter",
  ]
  const columns = [
    {
      name: "Actions",
      uid: "actions",
      align: COLUMN_ALIGN_TYPE.center,
    },
    {
      name: "Production Unit",
      uid: "unit_name",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,
    },
    
    {
      name: "Item",
      uid: "item_name",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      
    },
    {
        name: "Beam ",
        uid: "beam_no",
        sortable: true,
        align: COLUMN_ALIGN_TYPE.center,
      },
    {
        name: "Taka",
        uid: "taka",
        align: COLUMN_ALIGN_TYPE.center,
        sortable: true,
        footer: {
          type: FOOTER_TYPE.text,
          label: "Total: ",
          value: totalTAKA,
        },
      },
    {
      name: "METER",
      uid: "meter",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },

  ]
  const exportColumns = [{
    name: "Production Unit",
    uid: "unit_name",
  },
  {
    name: "item",
    uid: "item_name",
  },
  {
    name:"Beam",
    uid:"beam_no" 
 },
  {
    name: "Taka",
    uid: "taka",
  },
  {
    name: "Meter",
    uid: "meter",
  }
  ]

  let downloadDataFooter = {
    unit_name: "",
    item_name: "",
    beam_no:"",
    taka: " Total:" + totalTAKA,
    meter: ""
  }

  if (isError) {
    return <ErrorCard />
  }

  if (isPending) {
    return <LoadingCard />
  }



  const handleConfirmBox = (data) => {
    if (data) {

      FndeleteNote({
        data: {
          rp_id: itemToDelete.rp_id,
          comp_code: itemToDelete.comp_code,
          chal_no: itemToDelete.chal_no,
        }
      })
    }
    else {
      setItemToDelete("")
    }

  }

  const rowActionBtn = [
    {
      icon: <FontAwesomeIcon color="#379906" icon={faEdit} />,
      onClick: (row) => {
        let obj = {
          comp_code: compCode.join(","),
          id_no: row.idno,
        }
        
        disapatch(setDetailParams(obj))
        disapatch(setNewEntryMode(false))
        navigate(linksUrl.beamTransaction.beamCardEntry.createEntry)
      },
      type: ROW_ACTION_BTN_TYPE.link,
    },
    {
      icon: <FontAwesomeIcon color="#c40c18" icon={faTrash} />,
      onClick: (row) => {

        setItemToDelete({ comp_code: compCode.join(","),  id_no: row.idno })
      },
      type: ROW_ACTION_BTN_TYPE.link,
    },
  ]

  const handleAddNew = () => {
    disapatch(resetDetailParams())
    navigate(linksUrl.beamTransaction.beamCardEntry.createEntry)
  }



  return (
    <div>

      {itemToDelete != "" ? <ConfirmBox handleConfirmBox={handleConfirmBox} /> : ""}

      <MainContainer
        pageName="Beam Card"
        info={[]}
        breadcrumbs={[ "Beam Card Data"]}
      >
        <div className="" style={{ textAlign: "right" }}>
          <Button
            size="sm"
            color="primary"
            startContent={<FontAwesomeIcon icon={faPlus} />}
            onClick={handleAddNew}
          >
            Add New
          </Button>
        </div>

        <NextUITable
          INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
          data={data}
          columns={columns}
          rowActionBtn={rowActionBtn}
          exportColumns={exportColumns}
          downloadDataFooter={downloadDataFooter}
          downloadFileName="BeamCard-List"
          id="idno"
        ></NextUITable>
      </MainContainer>
    </div>
  )
}
export default BeamCardMaster
